import moment from 'moment';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import WeeksConversionLeadTimeLabel from './WeeksConversionLeadTimeLabel';
import { leadTimeInDaysCutoff } from './leadTimeCalculator';
import { formatDateShortMonthWithoutYear } from '@ami/react/core';

const LeadTimeFastTrackImage = () => (
  <img
    src="/assets/fasttrackleadtimes.png"
    className="img-fluid"
    alt=""
    style={{ marginRight: '3px', maxWidth: '25px' }}
  />
);

const EffectiveLeadTimeLabel = ({
  leadTimeDays,
  showLeadTimeCalculationSpinner,
  showDaysAndWeeks,
  isFastTrack,
  availableOn
}) => {

  if (leadTimeDays === null || leadTimeDays === undefined)
    return <Fragment>Call</Fragment>;

  const displayDays = leadTimeDays > 1 || leadTimeDays === 0 ? `${leadTimeDays} days` : `${leadTimeDays} day`;
  const isFutureDate = availableOn !== null && availableOn !== undefined && moment(availableOn).diff(moment(), "days") > 0;

  return (
    <Fragment>
      {showLeadTimeCalculationSpinner && <i className="fa fa-spin fa-spinner" />}

      {!showLeadTimeCalculationSpinner && (
        <Fragment>

          {isFastTrack && (
            <LeadTimeFastTrackImage />
          )}

          {leadTimeDays <= leadTimeInDaysCutoff && (
            <Fragment>
              {!isFutureDate && (
                <span>{leadTimeDays > 1 ? `${leadTimeDays} business days` : 'Next day'}</span>
              )}

              {isFutureDate && (
                <span>
                  {`${leadTimeDays} business ${leadTimeDays > 1 ? 'days' : 'day'} after ${formatDateShortMonthWithoutYear(availableOn)}`}
                </span>
              )}
            </Fragment>
          )}

          {leadTimeDays > leadTimeInDaysCutoff && (
            <Fragment>
              {showDaysAndWeeks && (
                <Fragment>
                  {!isFutureDate && (
                    <Fragment>
                      <span>{`${displayDays} `}</span>
                      <span>(<WeeksConversionLeadTimeLabel leadTimeDays={leadTimeDays} roundToNearestWeek={true} />)</span>
                    </Fragment>
                  )}

                  {isFutureDate && (
                    <Fragment>
                      <span>{`${displayDays} `}</span>
                      <span>(<WeeksConversionLeadTimeLabel leadTimeDays={leadTimeDays} roundToNearestWeek={true} />)</span>
                      <span>{` after ${formatDateShortMonthWithoutYear(availableOn)}`}</span>
                    </Fragment>
                  )}
                </Fragment>
              )}

              {!showDaysAndWeeks && (
                <Fragment>
                  {!isFutureDate && (
                    <WeeksConversionLeadTimeLabel leadTimeDays={leadTimeDays} roundToNearestWeek={true} />
                  )}

                  {isFutureDate && (
                    <Fragment>
                      <span><WeeksConversionLeadTimeLabel leadTimeDays={leadTimeDays} roundToNearestWeek={true} /></span>
                      <span>{` after ${formatDateShortMonthWithoutYear(availableOn)}`}</span>
                    </Fragment>
                  )}
                </Fragment>
              )}
            </Fragment>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

EffectiveLeadTimeLabel.propTypes = {
  leadTimeDays: PropTypes.number,
  showLeadTimeCalculationSpinner: PropTypes.bool,
  showDaysAndWeeks: PropTypes.bool,
  isFastTrack: PropTypes.bool,
  availableOn: PropTypes.string
};

EffectiveLeadTimeLabel.defaultProps = {
  showDaysAndWeeks: false
};

export default EffectiveLeadTimeLabel;
